// All API configuration in one place
export const BASE_URL = "https://v1-uat.my-api.me/pg-crm";

export const ENDPOINTS = {
  PAYMENT_DETAILS: "/checkout/v2/paymentDetails",
  PAY_REQ:         "/checkout/v2/paymentRequest",
  VERIFY_VPA:      "/checkout/v2/verifyVPA",
  PAYMENT_STATUS:  "/checkout/v2/paymentStatus",

  // Order-link generation (Java: OrderGenerateRequest)
  ORDER_REQUEST:   "/api/v2/req/orderRequest",
};

/**
 * Base URL used exclusively for the order-link generation API.
 * Kept separate because it targets a different path prefix than
 * the checkout endpoints above.
 */
export const ORDER_LINK_BASE_URL = BASE_URL;

/**
 * On localhost the API returns a paymentLink whose domain is the
 * production payment gateway. Replace that domain with localhost
 * so testers can follow the link directly.
 *
 * e.g. "https://payment.domain.com/..." → "http://localhost:3000/..."
 */
export const PAYMENT_LINK_PROD_DOMAIN = "https://payment.domain.com";
export const LOCALHOST_PAYMENT_BASE   = `http://localhost:${window.location.port || 3000}`;
